<!-- The dialog is the frame: the panel's own border would draw a second one inside it. -->
<pxc-dressfit-panel class="min-h-0 flex-1 border-0!" data-testid="dressfit-panel" />
